// extracted by mini-css-extract-plugin
export var exit = "_1-2";
export var fadeIn = "_1-1";
export var fadeOut = "_1-3";
export var notificationContainer = "_1-0";